<template>
    <div class="content">
        <div class="content--heading">
            <h1>Benutzer</h1>

            <div class="heading--actions">
                <a @click="openAddConfig" class="btn btn--icon">
                    <fa icon="plus-circle"></fa>
                </a>
            </div>
        </div>

        <div class="configurator-users panel panel--list">
            <div class="panel--filter">
                <div></div>
                <div class="panel--search">
                    <input type="text" v-model="userSearch" placeholder="Suchen ..."/>
                </div>
            </div>


            <div v-for="(user, uIndex) in filterUsers()" :key="uIndex" class="row" :class="{'deactive': !user.active}">
                <div class="cell title">
                    <fa icon="circle" class='user--state' :class="{'online': checkUserOnline(user.lastLogin)}"></fa>&nbsp;<span class="user--name" v-html="highlightSearch(user.username)"></span>
                </div>
                <div class="cell actions">
                    <span class="badge deactive" v-if="!user.active">deaktiviert</span>
                    <span class="badge" :class="user.role">{{user.role}}</span>
                    <div class="action action--edit">
                        <router-link :to="{ name: 'admin account', params: { userId: user.userId }}"
                                     v-if="userData.userId !== user.userId">
                            <fa icon="edit"></fa>
                        </router-link>
                        <router-link :to="{ name: 'own account'}" v-else>
                            <fa icon="edit"></fa>
                        </router-link>
                    </div>
                    <div class="action action--delete">
                        <fa icon="trash" @click="deleteUser(user.userId)"></fa>
                    </div>
                </div>
            </div>
        </div>
        <modals-container @refresh-users="loadUsers"/>
    </div>
</template>

<script>
    import modalAddUser from './modal/Add-User';

    export default {
        name: 'users',
        props: ['settings', 'userData'],
        data() {
            return {
                users: {},
                userSearch: ''
            }
        },
        async created() {
            let me = this;

            await me.loadUsers();
        },
        methods: {
            loadUsers: function() {
                let me = this;

                me.$http.get('/data/users').then(function (r) {
                    let response = r.data;

                    if (response.users) {
                        me.users = response.users;
                    }
                });
            },
            filterUsers: function () {
                let me = this,
                    result = {};

                if (me.users) {
                    for (let user in me.users) {
                        if (me.users.hasOwnProperty(user) && me.users[user].username.toLowerCase().includes(me.userSearch.toLowerCase())) {
                            result[user] = me.users[user];
                        }
                    }
                }


                return result;
            },
            highlightSearch: function (content) {
                let me = this;
                if (!me.userSearch) {
                    return content;
                }

                return content.replace(new RegExp(me.userSearch, 'gi'), match => {
                    return '<span class="highlight-search">' + match + '</span>';
                });
            },
            checkUserOnline: function(time) {
                let current = Date.now();

                return ((time * 1000) + (3 * 60 * 1000)) > current;
            },
            openAddConfig: function () {
                let me = this;

                this.$modal.show(modalAddUser, {
                    users: me.users
                }, {
                    height: 'auto',
                    classes: 'project--add-config v--modal vue-dialog'
                });
            },
            deleteUser: function (id) {
                let me = this;

                me.$modal.show('dialog', {
                    title: 'Benutzer löschen?',
                    text: 'Bist du dir sicher das du den Benutzer löschen möchtest? Nach dem Löschen kann der Benutzer nicht wiederhergestellt werden.',
                    buttons: [
                        {
                            title: 'NEIN, nicht löschen',
                            default: true,
                        },
                        {
                            title: 'JA, löschen',
                            class: 'vue-dialog-button delete',
                            handler: () => {
                                me.$modal.hide('dialog');
                                me.$http.delete('/data/users/' + id).then(function (r) {
                                    let response = r.data;

                                    if (response.users) {
                                        me.users = response.users;
                                    }

                                    me.$notify({
                                        text: response.msg,
                                        type: response.msgType
                                    });
                                });
                            }
                        }
                    ]
                });
            }
        }
    }
</script>